import { useFeatureValue } from '@monofront/business/contexts';
import { MINIMUM_ORDER_AMOUNT } from '@monofront/business/constants';
import { useGoogleShoppingContext } from '@context/googleShopping';

interface IUseMinimumOrderAmount {
  minimumOrderAmount: number;
}

const useMinimumOrderAmount = (): IUseMinimumOrderAmount => {
  const minimumOrderAmount = useFeatureValue(...MINIMUM_ORDER_AMOUNT);
  const { isFromGoogleShopping } = useGoogleShoppingContext();

  return { minimumOrderAmount: isFromGoogleShopping ? 0 : minimumOrderAmount };
};

export default useMinimumOrderAmount;
